<p-dialog
  [visible]="visible"
  (visibleChange)="visible = $event; visibleChange.emit($event)"
  [modal]="true"
  [draggable]="false"
  [style]="{ width: '480px' }"
  [header]="title"
  (onHide)="onHide()">
  <p class="clr-warning">{{ warning }}</p>
  <ul class="clr-links" *ngIf="links?.length">
    <li *ngFor="let link of links">
      <span class="clr-type">{{ link.type }}</span>
      <span class="clr-label">{{ link.label }}</span>
    </li>
  </ul>
  <p class="clr-note" *ngIf="!links?.length">No linked records.</p>
  <ng-template pTemplate="footer">
    <button type="button" class="pp-btn" (click)="onHide()" [disabled]="loading">
      Cancel
    </button>
    <button
      type="button"
      class="pp-btn pp-btn--danger"
      (click)="onConfirm()"
      [disabled]="loading">
      {{ loading ? 'Working…' : confirmLabel }}
    </button>
  </ng-template>
</p-dialog>
